import React, { memo } from 'react'
import { Link } from 'gatsby'

const Registration = () => (
  <section className="rg-section">
    <div className="rg-inner">
      <h2 className="rg-heading">
        You need it built right.<br />
        We make sure it stays that way.
      </h2>
      <p className="rg-sub">
        Every project we take on is a commitment — not just to ship software, but to deliver outcomes that hold up in production, under real users, over the long term. We measure our work by the quality our clients can stake their business on.
      </p>
      <Link to="/contact" className="rg-cta">
        Book a Free Consultation
      </Link>
    </div>
  </section>
)

export default memo(Registration)
